import { render, staticRenderFns } from "./ShippingData.vue?vue&type=template&id=514bacee&"
import script from "./ShippingData.vue?vue&type=script&lang=js&"
export * from "./ShippingData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports